const burguers = [
  {
    id: 1,
    title: "Burguer Max",
    thumb: "./assets/data_images/burguer.png",
    price: 8,
  },
  {
    id: 2,
    title: "Burguer Passion",
    thumb: "./assets/data_images/burguer.png",
    price: 10,
  },
  {
    id: 3,
    title: "Tex Mex Burguer",
    thumb: "./assets/data_images/burguer.png",
    price: 12,
  },
  {
    id: 4,
    title: "Space Burguer",
    thumb: "./assets/data_images/burguer.png",
    price: 11,
  },
  {
    id: 5,
    title: "Mega Cheese Burguer",
    thumb: "./assets/data_images/burguer.png",
    price: 18
  },
];

export default burguers;
